export default "__VITE_ASSET__Bs72rket__"